import styled from "@emotion/styled";

export const MidSectionCard = styled.div`
  box-shadow: -20px 15px #03406c;
  border-radius: 12px;
  overflow: hidden;
  height: clamp(150px, 25vw, 220px);
  width: clamp(300px, 35vw, 400px);
  background-color: transparent;
`;
